(function () {
  const KEY = "AIzaSyAFJQWg5a527xfXbxOeaN7GOGVR99UM0vU";
  const { gmaps_geolocation, range } = window.store_locator;

  let map;
  let current_iso_code;

  class Listing {
    constructor(store, { label = false, showDistance = false } = {}) {
      this.store = store;
      this.showDistance = showDistance;
      this.label = label;

      this.createElement();
    }

    async setWaitTime() {
      if (this.element && this.store.shortcuts_id && this.store.store_toggle) {
        // Initialize wait times for this specific location card using custom event
        document.dispatchEvent(new CustomEvent('dispatch:shop-data', {
          detail: {
            hours: false,
            waitTimes: true,
            wrapper: this.element,
            filter: this.store.shortcuts_id
          }
        }));

        /* Adds is-active to first location */
        const firstLocation = document.querySelector("ul.locations-nearest__list li:first-child");
        const hasIsFav = document.querySelector("ul.locations-nearest__list .is-fav");
        if (!hasIsFav && firstLocation) {
          firstLocation.classList.add("is-active");
        }
      } else if (!this.store.store_toggle) {
        const container = this.element.querySelector(".js-wait-time");
        if (container) {
          container.innerHTML = `
            <span class="wait-time__text eventSubtitle">${this.store.eventSubtitle}</span>
            <span class="wait-time__time">${this.store.eventTitle}</span>
          `;
          const checkBtn = ".CheckIn--" + this.store.shortcuts_id;
          this.element.querySelectorAll(checkBtn).forEach((e) => {
            e.style.display = "none"
          });
        }
      }
    }

    initWaitTime() {
      this.setWaitTime();
      this.waitTimeInterval = setInterval(this.setWaitTime.bind(this), 60000);
    }

    clearWaitTime() {
      if (this.waitTimeInterval) {
        clearInterval(this.waitTimeInterval);
      }
    }

    destroy() {
      if (this.element) {
        this.element.remove();
      }
      this.clearWaitTime();
    }

    createElement() {
      // Find the existing card with matching shortcut ID
      const existingCard = document.querySelector(`.location[data-shortcut-id="${this.store.shortcuts_id}"]`);

      if (!existingCard) {
        console.warn(`No existing card found for location: ${this.store.name}`);
        return;
      }

      // Clone the existing card
      const element = existingCard.cloneNode(true);

      // Add distance if needed
      if (this.showDistance && this.store.distance) {
        const distanceText = current_iso_code === 'CA'
          ? `${Math.round(this.store.distance * 10) / 10}km`
          : `${Math.round(this.store.distance * 10 * 0.62137119) / 10}mi`;

        const distanceElement = document.createElement('span');
        distanceElement.classList.add('location__distance');
        distanceElement.textContent = distanceText;

        // Insert distance after the title
        const titleElement = element.querySelector('.location__title');
        if (titleElement) {
          titleElement.insertAdjacentElement('afterend', distanceElement);
        }
      }

      // Add click event listener for map interaction
      element.addEventListener("click", (event) => {
        // Check if the clicked element or any of its ancestors are <a> tags
        if (event.target.closest('a') || event.target.closest('svg:not(.fav-location)')) {
          return;
        }
        if (map && map.focusStore) {
          map.focusStore(this.store);
        }
      });

      this.element = element;
    }
  }

  class Store {
    constructor(data = {}) {
      // console.log(data);
      Object.entries(data).forEach(([key, value]) => {
        this[key] = value;
      });
    }

    getDistance(position) {
      // Guard against undefined position
      if (!position || typeof position.lat === 'undefined' || typeof position.lng === 'undefined') {
        return Infinity;
      }

      const R = 6371; // Radius of the earth in km
      const convertToRad = (deg) => {
        return deg * (Math.PI / 180);
      };

      // if (this.name === "SanTan Village") {
      //   console.log("this.location.lat",this.location.lat)
      //   console.log("this.location.lng",this.location.lng)
      //   console.log("position.lat",position.lat)
      //   console.log("position.lng",position.lng)
      // }
      const distanceLat = convertToRad(this.location.lat - position.lat);
      const distanceLng = convertToRad(this.location.lng - position.lng);

      const a =
        Math.sin(distanceLat / 2) * Math.sin(distanceLat / 2) +
        Math.cos(convertToRad(position.lat)) *
        Math.cos(convertToRad(this.location.lat)) *
        Math.sin(distanceLng / 2) *
        Math.sin(distanceLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const d = R * c; // Distance in km

      return d;
    }

    initWaitTime() {
      this.clearWaitTime();
      this.setWaitTime();
      this.waitTimeInterval = setInterval(this.setWaitTime.bind(this), 60000);
    }

    clearWaitTime() {
      if (this.waitTimeInterval) {
        clearInterval(this.waitTimeInterval);
      }
    }

    addMarker(map) {
      // Function to create the marker content
      const createMarkerContent = () => {
        const wrapper = document.createElement("div");
        wrapper.className = "tg-marker";

        // Use template literals to create the SVG and HTML content
        wrapper.innerHTML = `
          <div class="marker-label">
            ${this.name}
            <p>View Details</p>
          </div>
          <svg class="custom-marker__icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000">
              <path d="M12 2c-4.2 0-8 3.22-8 8.2 0 3.18 2.45 6.92 7.34 11.23.38.33.95.33 1.33 0C17.55 17.12 20 13.38 20 10.2 20 5.22 16.2 2 12 2zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
          </svg>
        `;

        return wrapper;
      };

      // Create the marker
      this.marker = new google.maps.marker.AdvancedMarkerElement({
        map,
        position: this.location,
        content: createMarkerContent(), // Add the custom HTML content
        title: this.name, // Tooltip text on hover
      });
    }
  }

  class Map {
    constructor(container) {
      this.events = {};
      this.elements = {
        map: container,
        nearestStoresList: document.querySelector(".js-nearest-stores"),
        nearestStoresCount: document.querySelector(".js-nearest-stores-count"),
        storesList: document.querySelectorAll('.js-stores-list .location'),
        nearbyContainer: document.querySelector(".locations-nearest"),
        locationsNearestList: document.querySelector(".locations-nearest__list"),
        staticLocations: document.querySelector(".locations-static"),
        loader: document.querySelector(".loader-wrapper")
      };

      this._location = {
        lat: 50.885859584611325,
        lng: -89.17573073012652,
      };

      this.getStores().then(() => {
        this.emit('storesReady');
      });
      this.bindEvents();

      this.listings = [];
      this.listingsNearby = [];
      this.cachedGeocodes = {};

      window.myMap = this;
    }

    on(eventName, callback) {
      if (!this.events[eventName]) {
        this.events[eventName] = [];
      }
      this.events[eventName].push(callback);
    }

    emit(eventName, ...args) {
      if (this.events[eventName]) {
        this.events[eventName].forEach(callback => callback(...args));
      }
    }

    load() {
      // console.log("current location when centering", this.userLocation);
      this.loaded = true;
      this.map = new google.maps.Map(this.elements.map, {
        center: this.userLocation,
        mapId: "5d278bcd39e22421",
        zoom: 14,
        clickableIcons: false
      });

      this.setMarkers();

      if (this.geocoded || this.geolocated) {
        setTimeout(() => {
          this.updateNearestStores();
        }, 300);
      }
    }

    set userLocation(location) {
      // Guard against undefined location
      if (!location || typeof location.lat === 'undefined' || typeof location.lng === 'undefined') {
        console.warn('Invalid location provided:', location);
        return;
      }

      this._location = location;
      this.updateNearestStores();
      $(".btn--checkin").on("click", function () {
        $("#checkinButton").attr("href", $(this).data("bs-url"));
      });
    }

    get userLocation() {
      return this._location;
    }

    geocode(input) {
      const address = input.toLowerCase();

      if (address) {
        // Save some API requests if possible
        if (this.cachedGeocodes[address]) {
          this.userLocation = this.cachedGeocodes[address];
        } else {
          this.geocoder = this.geocoder || new google.maps.Geocoder();

          this.geocoder.geocode(
            {
              address: `${address}`,
            },
            (results, status) => {
              if (status == "OK") {
                const respLocation = results[0].geometry.location;
                const location = {
                  lat: respLocation.lat(),
                  lng: respLocation.lng(),
                };

                this.geocoded = true;
                this.userLocation = location;
                this.cachedGeocodes[address] = location;
              } else {
                console.warn("Geocode was not successful: " + status);
              }
            }
          );
        }
      }
    }

    async geolocate() {
      if (gmaps_geolocation) {
        if (this.cachedGeolocation) {
          // console.log("using location from cache",this.cachedGeolocation)
          this.userLocation = this.cachedGeolocation;
        } else {
          try {
            // console.log("apicall")
            const response = await fetch(
              `https://www.googleapis.com/geolocation/v1/geolocate?key=${KEY}`,
              { method: "POST" }
            );

            if (!response.ok) {
              throw new Error(`Geolocation API error: ${response.status} ${response.statusText}`);
            }

            const { location } = await response.json();
            // console.log("using location from Google API", location);
            // const location = {
            //   lat: 51.2688128,
            //   lng: -113.9900416
            // };

            this.geolocated = true;
            this.cachedGeolocation = location;
            this.userLocation = location;
            // console.log('this.userLocation', this.userLocation)
          } catch (error) {
            console.warn("Geolocation failed:", error);
            // Show "no locations near you" message
            this.showNoLocationsMessage();
          }
        }
      } else {
        this.showNoLocationsMessage();
      }
    }

    showNoLocationsMessage(range) {
      // Show "no locations near you" message when geolocation fails
      if (this.elements.nearbyContainer.style.display === "none") {
        $(this.elements.nearbyContainer).slideDown();
      }

      let noResultsHTML;
      this.clearNearestStores();
      this.elements.loader.classList.add('d-none');

      if (range) {
        noResultsHTML = `
          <div class="locations-nearest__no-results mx-auto text-center m-auto">
            <p>
              <b>SORRY!</b> We could not locate a barbershop within ${range}km of your detected location.
              <p class="mb-0">Please find your nearest barbershop below.</p>
            </p>
          </div>`;
      } else {
        noResultsHTML = `
          <div class="locations-nearest__no-results mx-auto text-center m-auto">
            <p>
              <b>SORRY!</b> We could not locate a barbershop near your detected location.
            </p>
            <p class="mb-0">Please find your nearest barbershop below.</p>
          </div>`;
      }
      this.elements.nearbyContainer.innerHTML = noResultsHTML;
      this.elements.nearestStoresCount.innerHTML = ` (0)`;
      this.elements.staticLocations.classList.remove('loading');
    }

    async getStores() {
      try {
        const response = await fetch("/blogs/news?view=json");
        const { iso_code, locations } = await response.json();

        current_iso_code = iso_code;

        this.stores = locations
          .filter(
            (store) =>
              store.address &&
              typeof store.address === "string" &&
              store.shortcuts_id &&
              store.location &&
              store.country
          )
          .map((store) => new Store(store));

        if (window.getComputedStyle(this.elements.map).display !== "none") {
          this.load();
        } else {
          window.addEventListener("resize", () => {
            if (
              window.getComputedStyle(this.elements.map).display !== "none" &&
              !this.loaded
            ) {
              this.load();
            }
          });
        }

        this.geolocate();
      } catch (error) {
        console.error("Failed to load stores:", error);
        // Show error message to user
        this.showNoLocationsMessage();
      }
    }

    focusStore = (store) => {
      const targetLocation = new google.maps.LatLng(store.location.lat, store.location.lng);
      //console.log('this listings:', [...this.listings], 'nearby', [...this.listingsNearby]);

      [...this.listingsNearby, ...this.listings].forEach((listing) => {
        const activeStore = Boolean(listing.store.shortcuts_id === store.shortcuts_id);

        listing.element.classList.toggle("is-active", activeStore);
      });

      if (this.map) {
        const initialLocation = this.map.getCenter();
        const bounds = new google.maps.LatLngBounds();
        bounds.extend(initialLocation);
        bounds.extend(targetLocation);

        this.map.fitBounds(bounds);

        const zoomChangeBoundsListener = google.maps.event.addListenerOnce(this.map, "bounds_changed", () => {
          if (this.map.getZoom() > 15) {
            this.map.setZoom(15);
          }
        });

        const tilesLoadedListener = google.maps.event.addListenerOnce(this.map, "tilesloaded", () => {
          google.maps.event.removeListener(zoomChangeBoundsListener);
          this.map.panTo(targetLocation);
        });

        // Remove the tiles loaded event listener after 2 seconds (adjust as needed)
        setTimeout(() => {
          google.maps.event.removeListener(tilesLoadedListener);
        }, 2000);
      }
    };

    clearNearestStores() {
      if (this.elements.nearestStoresList) {
        this.elements.nearestStoresList.innerHTML = "";
      }
      this.listingsNearby.forEach((listing) => {
        listing.destroy();
      });
      this.listingsNearby = [];
    }

    updateNearestStores() {
      if (!this.userLocation || typeof this.userLocation.lat === 'undefined') {
        console.warn('No valid user location available for nearby stores');
        this.showNoLocationsMessage();
        return;
      }

      if (this.elements.nearbyContainer.style.display === "none") {
        $(this.elements.nearbyContainer).slideDown();
      }

      this.stores.forEach((store) => {
        store.distance = store.getDistance(this.userLocation);
      });

      const storesByDistance = this.stores
        .filter((store) => store.distance <= range)
        .sort((a, b) => a.distance - b.distance);

      if (this.map) {
        // Center map on the closest store
        const closestStore = storesByDistance[0];
        this.map.setCenter(closestStore.location);
        this.map.setZoom(14);
      }

      this.clearNearestStores();

      if (storesByDistance.length) {
        this.listingsNearby = storesByDistance.map(
          (store, index) =>
            new Listing(store, {
              showDistance: true,
              label: index + 1,
            })
        );

        this.listingsNearby.forEach((listing, index) => {
          this.elements.nearestStoresList.appendChild(listing.element);
          listing.initWaitTime();
        });

        // Initialize check-in functionality after all cards are added
        if (window.initializeCheckInLinks) {
          window.initializeCheckInLinks();
        }

        this.elements.loader.classList.remove('d-none');
      } else {
        this.showNoLocationsMessage(range);
      }

      this.elements.nearestStoresCount.innerHTML = ` (${storesByDistance.length})`;
      this.elements.loader.classList.add('d-none');
      this.elements.staticLocations.classList.remove('loading');
    }

    setMarkers() {
      this.stores.forEach((store) => {
        // console.log('This Map', this.map)
        // console.log('Store', store)
        store.addMarker(this.map);

        if (store.marker) {
          store.marker.addListener("click", () => {
            // this.focusStore(store);
            window.location.href = store.url;
          });
        }
      });
    }

    bindEvents() {
      const addressInput = document.querySelector(".js-map-search-input");
      const searchForm = document.querySelector(".js-map-search-form");

      if (searchForm) {
        searchForm.addEventListener("submit", (e) => {
          e.preventDefault();
          const address = addressInput?.value;
          if (address) {
            this.geocode(address);
          }
        });
      }

      const geolocateBtn = document.querySelector(".js-geolocate");
      if (geolocateBtn) {
        geolocateBtn.addEventListener("click", (e) => {
          e.preventDefault();
          this.geolocate();
        });
      }
    }
  }

  function initMap() {
    map = new Map(document.getElementById("map"));
    map.on('storesReady', () => {
      addListenersToStaticCards(map);
    });
  }

  function loadGoogleMaps() {
    var script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${KEY}&loading=async&callback=initMap&v=weekly&libraries=marker`;
    script.async = true;

    window.initMap = initMap;

    document.head.appendChild(script);
  }

  function mapToggle() {
    const showMap = document.querySelector(".js-show-map");
    const $map = $("#map");
    let loaded = false;

    if (showMap) {
      showMap.addEventListener("click", () => {
        if (!loaded) {
          $map.load();
          loaded = true;
        }

        $map.slideToggle();
        showMap.classList.toggle("is-active");
      });
    }
  }

  // Static location cards
  function addListenersToStaticCards(map) {
    map.listings = map.stores
      .sort(({ name: a }, { name: b }) => (a < b ? -1 : 1))
      .map((store) => new Listing(store));
    const stores = map.stores
    document.querySelectorAll('.js-stores-list .location').forEach((elem, index) => {
      const shortcuts_id = elem.dataset.shortcutId;
      const store = stores.find(shop => shop.shortcuts_id === shortcuts_id);
      if (store) {
        elem.addEventListener("click", (event) => {
          map.focusStore(store);
        });
      }
    });
  }

  window.addEventListener("load", () => {
    loadGoogleMaps();
    mapToggle();
  });
})();